<template>
    <div>
      <serviceType-list></serviceType-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  